import React, { useState, useEffect } from 'react'
import { Nav, Input, InputGroup, SelectPicker } from 'rsuite'
import PlusIcon from '@rsuite/icons/Plus'
import './toolbar.scss'
import Button from 'shared/atoms/button/Button'

interface DropdownOption {
  label: string;
  value: string;
}
interface Props {
  options: { label: string, value: string, onClick: () => void }[];
  buttonName?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  viewButton?: string;
  backButton?: string;
  onButtonClick?: () => void;
  total?: number;
  dropdownData?: DropdownOption[];
  onSearchChange?: (value: string) => void;
  onDropdownSelect?: (value: string) => void;
  searchable?: boolean;
  selectedDropdownValue?: string;
  dropdownPlaceholder?: string;
}

const Toolbar: React.FC<Props> = ({
  options,
  buttonName,
  onButtonClick,
  backButton,
  viewButton,
  total,
  dropdownData,
  searchable,
  onSearchChange,
  selectedDropdownValue,
  onDropdownSelect,
  dropdownPlaceholder
}) => {
  const [selectedValue, setSelectedValue] = useState<string | null>('')
  const [active, setActive] = useState(options[0]?.value)
  const [searchValue, setSearchValue] = useState('')
  const debounceDelay = 300
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchValue)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchValue)
    }, debounceDelay)

    return () => {
      clearTimeout(handler)
    }
  }, [searchValue])

  useEffect(() => {
    onSearchChange?.(debouncedSearchTerm)
  }, [debouncedSearchTerm, onSearchChange])

  const onNavSelect = (
    activeKey: string,
    option: { label: string, value: string, onClick: () => void }
  ) => {
    setActive(activeKey)
    option.onClick()
  }

  const handleDropdownChange = (value: string | null) => {
    setSelectedValue(value)
    onDropdownSelect?.(value ?? '')
  }

  return (
    <div className="toolbar">
      <div className="toolbar-left">
        <Nav appearance="subtle" activeKey={active} style={{ marginRight: 10 }}>
          {options.map((option) => (
            <Nav.Item
              key={option.value}
              eventKey={option.value}
              onClick={() => onNavSelect(option.value, option)}
            >
              {option.label}
            </Nav.Item>
          ))}
        </Nav>
        <div className="toolbar-totals">
          {total !== undefined && (
            <span>Total {total}</span>
          )}
        </div>
      </div>
      <div className="toolbar-right-pane">
        {onDropdownSelect && (
          <div className="toolbar-dropdown">
            <SelectPicker
              placeholder={dropdownPlaceholder || ''}
              style={{ width: 203, marginRight: 20 }}
              searchable={searchable ?? false}
              value={selectedDropdownValue ?? selectedValue}
              onChange={(value, event) => handleDropdownChange(value)}
              // eslint-disable-next-line react/jsx-boolean-value
              cleanable={true}
              data={dropdownData ?? []}
            />
          </div>
        )}
        {onSearchChange && (
          <div>
            <InputGroup size="md" style={{ width: 200, margin: 10 }}>
              <Input
                placeholder="Search"
                onChange={(value: string) => setSearchValue(value)}
              />
              {/* <InputGroup.Addon>
                <IconButton icon={<SearchIcon />} />
              </InputGroup.Addon> */}
            </InputGroup>
          </div>
        )}
        {buttonName && (
          <Button
            className="toolbar-btn"
            startIcon={<PlusIcon />}
            onClick={onButtonClick}
          >
            {buttonName}
          </Button>
        )}
        {viewButton && (
          <Button
            className="toolbar-btn"
            // startIcon={<PlusIcon />}
            onClick={onButtonClick}
          >
            {viewButton}
          </Button>
        )}
        {backButton && (
          <Button
            className="toolbar-btn"
            startIcon={
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 12 32"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
                className="rs-icon"
                aria-label="angle left"
                data-category="legacy"
              >
                <path d="M11.196 9.714a.612.612 0 01-.179.411l-7.018 7.018 7.018 7.018c.107.107.179.268.179.411s-.071.304-.179.411l-.893.893c-.107.107-.268.179-.411.179s-.304-.071-.411-.179L.981 17.555c-.107-.107-.179-.268-.179-.411s.071-.304.179-.411l8.321-8.321c.107-.107.268-.179.411-.179s.304.071.411.179l.893.893c.107.107.179.25.179.411z" />
              </svg>
            }
            onClick={onButtonClick}
          >
            {backButton}
          </Button>
        )}
      </div>
    </div>
  )
}

export default Toolbar
